/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  BodyManufactureToPurchase,
  ExportWarehousesParams,
  GetParentProductsParams,
  GetWarehousePredictions200,
  GetWarehousesParams,
  HTTPValidationError,
  PageCatalogProductWithWarehouseBase,
  PageWarehouseWithIncomingQuantity,
  WarehouseCreate,
  WarehouseRead,
} from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * Route to create a new warehouse.
 * @summary Create Warehouse
 */
export const createWarehouse = (
  warehouseCreate: WarehouseCreate,
  signal?: AbortSignal,
) => {
  return customInstance<number>({
    url: `/api/warehouse/`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: warehouseCreate,
    signal,
  });
};

export const getCreateWarehouseMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createWarehouse>>,
    TError,
    { data: WarehouseCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createWarehouse>>,
  TError,
  { data: WarehouseCreate },
  TContext
> => {
  const mutationKey = ["createWarehouse"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createWarehouse>>,
    { data: WarehouseCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createWarehouse(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateWarehouseMutationResult = NonNullable<
  Awaited<ReturnType<typeof createWarehouse>>
>;
export type CreateWarehouseMutationBody = WarehouseCreate;
export type CreateWarehouseMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Warehouse
 */
export const useCreateWarehouse = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createWarehouse>>,
      TError,
      { data: WarehouseCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createWarehouse>>,
  TError,
  { data: WarehouseCreate },
  TContext
> => {
  const mutationOptions = getCreateWarehouseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get many warehouse items.

Results are paginated.
 * @summary Get Warehouses
 */
export const getWarehouses = (
  params?: GetWarehousesParams,
  signal?: AbortSignal,
) => {
  return customInstance<PageWarehouseWithIncomingQuantity>({
    url: `/api/warehouse/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetWarehousesInfiniteQueryKey = (
  params?: GetWarehousesParams,
) => {
  return ["infinite", "api", "warehouse", ...(params ? [params] : [])] as const;
};

export const getGetWarehousesQueryKey = (params?: GetWarehousesParams) => {
  return ["api", "warehouse", ...(params ? [params] : [])] as const;
};

export const getGetWarehousesInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getWarehouses>>,
    GetWarehousesParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetWarehousesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getWarehouses>>,
        TError,
        TData,
        QueryKey,
        GetWarehousesParams["page"]
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetWarehousesInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWarehouses>>,
    QueryKey,
    GetWarehousesParams["page"]
  > = ({ signal, pageParam }) =>
    getWarehouses({ ...params, page: pageParam || params?.["page"] }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getWarehouses>>,
    TError,
    TData,
    QueryKey,
    GetWarehousesParams["page"]
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetWarehousesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWarehouses>>
>;
export type GetWarehousesInfiniteQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetWarehousesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getWarehouses>>,
    GetWarehousesParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetWarehousesParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getWarehouses>>,
        TError,
        TData,
        QueryKey,
        GetWarehousesParams["page"]
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWarehouses>>,
          TError,
          Awaited<ReturnType<typeof getWarehouses>>,
          QueryKey
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWarehousesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getWarehouses>>,
    GetWarehousesParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetWarehousesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getWarehouses>>,
        TError,
        TData,
        QueryKey,
        GetWarehousesParams["page"]
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWarehouses>>,
          TError,
          Awaited<ReturnType<typeof getWarehouses>>,
          QueryKey
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWarehousesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getWarehouses>>,
    GetWarehousesParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetWarehousesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getWarehouses>>,
        TError,
        TData,
        QueryKey,
        GetWarehousesParams["page"]
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Warehouses
 */

export function useGetWarehousesInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getWarehouses>>,
    GetWarehousesParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetWarehousesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getWarehouses>>,
        TError,
        TData,
        QueryKey,
        GetWarehousesParams["page"]
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetWarehousesInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetWarehousesQueryOptions = <
  TData = Awaited<ReturnType<typeof getWarehouses>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetWarehousesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWarehouses>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWarehousesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWarehouses>>> = ({
    signal,
  }) => getWarehouses(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWarehouses>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetWarehousesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWarehouses>>
>;
export type GetWarehousesQueryError = ErrorType<void | HTTPValidationError>;

export function useGetWarehouses<
  TData = Awaited<ReturnType<typeof getWarehouses>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetWarehousesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWarehouses>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWarehouses>>,
          TError,
          Awaited<ReturnType<typeof getWarehouses>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWarehouses<
  TData = Awaited<ReturnType<typeof getWarehouses>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetWarehousesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWarehouses>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWarehouses>>,
          TError,
          Awaited<ReturnType<typeof getWarehouses>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWarehouses<
  TData = Awaited<ReturnType<typeof getWarehouses>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetWarehousesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWarehouses>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Warehouses
 */

export function useGetWarehouses<
  TData = Awaited<ReturnType<typeof getWarehouses>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetWarehousesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWarehouses>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetWarehousesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Export warehouse items to CSV with true streaming.
 * @summary Export Warehouses
 */
export const exportWarehouses = (
  params?: ExportWarehousesParams,
  signal?: AbortSignal,
) => {
  return customInstance<Blob>({
    url: `/api/warehouse/export`,
    method: "GET",
    params,
    responseType: "blob",
    signal,
  });
};

export const getExportWarehousesQueryKey = (
  params?: ExportWarehousesParams,
) => {
  return ["api", "warehouse", "export", ...(params ? [params] : [])] as const;
};

export const getExportWarehousesQueryOptions = <
  TData = Awaited<ReturnType<typeof exportWarehouses>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportWarehousesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportWarehouses>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExportWarehousesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportWarehouses>>
  > = ({ signal }) => exportWarehouses(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportWarehouses>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExportWarehousesQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportWarehouses>>
>;
export type ExportWarehousesQueryError = ErrorType<void | HTTPValidationError>;

export function useExportWarehouses<
  TData = Awaited<ReturnType<typeof exportWarehouses>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | ExportWarehousesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportWarehouses>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportWarehouses>>,
          TError,
          Awaited<ReturnType<typeof exportWarehouses>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExportWarehouses<
  TData = Awaited<ReturnType<typeof exportWarehouses>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportWarehousesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportWarehouses>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportWarehouses>>,
          TError,
          Awaited<ReturnType<typeof exportWarehouses>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExportWarehouses<
  TData = Awaited<ReturnType<typeof exportWarehouses>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportWarehousesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportWarehouses>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Export Warehouses
 */

export function useExportWarehouses<
  TData = Awaited<ReturnType<typeof exportWarehouses>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: ExportWarehousesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportWarehouses>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExportWarehousesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to get an warehouse by ID.
 * @summary Get Warehouse
 */
export const getWarehouse = (warehouseId: number, signal?: AbortSignal) => {
  return customInstance<WarehouseRead>({
    url: `/api/warehouse/${warehouseId}`,
    method: "GET",
    signal,
  });
};

export const getGetWarehouseQueryKey = (warehouseId?: number) => {
  return ["api", "warehouse", warehouseId] as const;
};

export const getGetWarehouseQueryOptions = <
  TData = Awaited<ReturnType<typeof getWarehouse>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  warehouseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWarehouse>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetWarehouseQueryKey(warehouseId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWarehouse>>> = ({
    signal,
  }) => getWarehouse(warehouseId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!warehouseId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWarehouse>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetWarehouseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWarehouse>>
>;
export type GetWarehouseQueryError = ErrorType<void | HTTPValidationError>;

export function useGetWarehouse<
  TData = Awaited<ReturnType<typeof getWarehouse>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  warehouseId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWarehouse>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWarehouse>>,
          TError,
          Awaited<ReturnType<typeof getWarehouse>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWarehouse<
  TData = Awaited<ReturnType<typeof getWarehouse>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  warehouseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWarehouse>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWarehouse>>,
          TError,
          Awaited<ReturnType<typeof getWarehouse>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWarehouse<
  TData = Awaited<ReturnType<typeof getWarehouse>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  warehouseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWarehouse>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Warehouse
 */

export function useGetWarehouse<
  TData = Awaited<ReturnType<typeof getWarehouse>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  warehouseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getWarehouse>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetWarehouseQueryOptions(warehouseId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to update an warehouse by ID.
 * @summary Update Warehouse
 */
export const updateWarehouse = (
  warehouseId: number,
  warehouseCreate: WarehouseCreate,
) => {
  return customInstance<number>({
    url: `/api/warehouse/${warehouseId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: warehouseCreate,
  });
};

export const getUpdateWarehouseMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateWarehouse>>,
    TError,
    { warehouseId: number; data: WarehouseCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateWarehouse>>,
  TError,
  { warehouseId: number; data: WarehouseCreate },
  TContext
> => {
  const mutationKey = ["updateWarehouse"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateWarehouse>>,
    { warehouseId: number; data: WarehouseCreate }
  > = (props) => {
    const { warehouseId, data } = props ?? {};

    return updateWarehouse(warehouseId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateWarehouseMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateWarehouse>>
>;
export type UpdateWarehouseMutationBody = WarehouseCreate;
export type UpdateWarehouseMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Warehouse
 */
export const useUpdateWarehouse = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateWarehouse>>,
      TError,
      { warehouseId: number; data: WarehouseCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateWarehouse>>,
  TError,
  { warehouseId: number; data: WarehouseCreate },
  TContext
> => {
  const mutationOptions = getUpdateWarehouseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get all products that contain the given warehouse item as a component.

Results are paginated.
 * @summary Get Parent Products
 */
export const getParentProducts = (
  warehouseId: number,
  params?: GetParentProductsParams,
  signal?: AbortSignal,
) => {
  return customInstance<PageCatalogProductWithWarehouseBase>({
    url: `/api/warehouse/${warehouseId}/parent_products`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetParentProductsQueryKey = (
  warehouseId?: number,
  params?: GetParentProductsParams,
) => {
  return [
    "api",
    "warehouse",
    warehouseId,
    "parent_products",
    ...(params ? [params] : []),
  ] as const;
};

export const getGetParentProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof getParentProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  warehouseId: number,
  params?: GetParentProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getParentProducts>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetParentProductsQueryKey(warehouseId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getParentProducts>>
  > = ({ signal }) => getParentProducts(warehouseId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!warehouseId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getParentProducts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetParentProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getParentProducts>>
>;
export type GetParentProductsQueryError = ErrorType<void | HTTPValidationError>;

export function useGetParentProducts<
  TData = Awaited<ReturnType<typeof getParentProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  warehouseId: number,
  params: undefined | GetParentProductsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getParentProducts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getParentProducts>>,
          TError,
          Awaited<ReturnType<typeof getParentProducts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetParentProducts<
  TData = Awaited<ReturnType<typeof getParentProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  warehouseId: number,
  params?: GetParentProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getParentProducts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getParentProducts>>,
          TError,
          Awaited<ReturnType<typeof getParentProducts>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetParentProducts<
  TData = Awaited<ReturnType<typeof getParentProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  warehouseId: number,
  params?: GetParentProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getParentProducts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Parent Products
 */

export function useGetParentProducts<
  TData = Awaited<ReturnType<typeof getParentProducts>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  warehouseId: number,
  params?: GetParentProductsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getParentProducts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetParentProductsQueryOptions(
    warehouseId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to get the warehouse predictions and sales history for graphing.
 * @summary Get Warehouse Predictions
 */
export const getWarehousePredictions = (
  warehouseId: number,
  signal?: AbortSignal,
) => {
  return customInstance<GetWarehousePredictions200>({
    url: `/api/warehouse/${warehouseId}/predictions`,
    method: "GET",
    signal,
  });
};

export const getGetWarehousePredictionsQueryKey = (warehouseId?: number) => {
  return ["api", "warehouse", warehouseId, "predictions"] as const;
};

export const getGetWarehousePredictionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getWarehousePredictions>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  warehouseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWarehousePredictions>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetWarehousePredictionsQueryKey(warehouseId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getWarehousePredictions>>
  > = ({ signal }) => getWarehousePredictions(warehouseId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!warehouseId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getWarehousePredictions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetWarehousePredictionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getWarehousePredictions>>
>;
export type GetWarehousePredictionsQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetWarehousePredictions<
  TData = Awaited<ReturnType<typeof getWarehousePredictions>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  warehouseId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWarehousePredictions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWarehousePredictions>>,
          TError,
          Awaited<ReturnType<typeof getWarehousePredictions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWarehousePredictions<
  TData = Awaited<ReturnType<typeof getWarehousePredictions>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  warehouseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWarehousePredictions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWarehousePredictions>>,
          TError,
          Awaited<ReturnType<typeof getWarehousePredictions>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetWarehousePredictions<
  TData = Awaited<ReturnType<typeof getWarehousePredictions>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  warehouseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWarehousePredictions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Warehouse Predictions
 */

export function useGetWarehousePredictions<
  TData = Awaited<ReturnType<typeof getWarehousePredictions>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  warehouseId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getWarehousePredictions>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetWarehousePredictionsQueryOptions(
    warehouseId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to convert a warehouse item from manufactured to purchased.
 * @summary Manufacture To Purchase
 */
export const manufactureToPurchase = (
  warehouseId: number,
  bodyManufactureToPurchase: BodyManufactureToPurchase,
) => {
  return customInstance<number>({
    url: `/api/warehouse/${warehouseId}/manufacture-to-purchase`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: bodyManufactureToPurchase,
  });
};

export const getManufactureToPurchaseMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof manufactureToPurchase>>,
    TError,
    { warehouseId: number; data: BodyManufactureToPurchase },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof manufactureToPurchase>>,
  TError,
  { warehouseId: number; data: BodyManufactureToPurchase },
  TContext
> => {
  const mutationKey = ["manufactureToPurchase"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof manufactureToPurchase>>,
    { warehouseId: number; data: BodyManufactureToPurchase }
  > = (props) => {
    const { warehouseId, data } = props ?? {};

    return manufactureToPurchase(warehouseId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ManufactureToPurchaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof manufactureToPurchase>>
>;
export type ManufactureToPurchaseMutationBody = BodyManufactureToPurchase;
export type ManufactureToPurchaseMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Manufacture To Purchase
 */
export const useManufactureToPurchase = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof manufactureToPurchase>>,
      TError,
      { warehouseId: number; data: BodyManufactureToPurchase },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof manufactureToPurchase>>,
  TError,
  { warehouseId: number; data: BodyManufactureToPurchase },
  TContext
> => {
  const mutationOptions = getManufactureToPurchaseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to convert a warehouse item from purchased to manufactured.
 * @summary Purchase To Manufacture
 */
export const purchaseToManufacture = (warehouseId: number) => {
  return customInstance<number>({
    url: `/api/warehouse/${warehouseId}/purchase-to-manufacture`,
    method: "PUT",
  });
};

export const getPurchaseToManufactureMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof purchaseToManufacture>>,
    TError,
    { warehouseId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof purchaseToManufacture>>,
  TError,
  { warehouseId: number },
  TContext
> => {
  const mutationKey = ["purchaseToManufacture"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof purchaseToManufacture>>,
    { warehouseId: number }
  > = (props) => {
    const { warehouseId } = props ?? {};

    return purchaseToManufacture(warehouseId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PurchaseToManufactureMutationResult = NonNullable<
  Awaited<ReturnType<typeof purchaseToManufacture>>
>;

export type PurchaseToManufactureMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Purchase To Manufacture
 */
export const usePurchaseToManufacture = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof purchaseToManufacture>>,
      TError,
      { warehouseId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof purchaseToManufacture>>,
  TError,
  { warehouseId: number },
  TContext
> => {
  const mutationOptions = getPurchaseToManufactureMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to archive or unarchive a warehouse by ID.
 * @summary Archive Warehouse
 */
export const archiveWarehouse = (
  warehouseId: number,
  shouldArchive: boolean,
) => {
  return customInstance<unknown>({
    url: `/api/warehouse/${warehouseId}/archive/${shouldArchive}`,
    method: "PUT",
  });
};

export const getArchiveWarehouseMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveWarehouse>>,
    TError,
    { warehouseId: number; shouldArchive: boolean },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof archiveWarehouse>>,
  TError,
  { warehouseId: number; shouldArchive: boolean },
  TContext
> => {
  const mutationKey = ["archiveWarehouse"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof archiveWarehouse>>,
    { warehouseId: number; shouldArchive: boolean }
  > = (props) => {
    const { warehouseId, shouldArchive } = props ?? {};

    return archiveWarehouse(warehouseId, shouldArchive);
  };

  return { mutationFn, ...mutationOptions };
};

export type ArchiveWarehouseMutationResult = NonNullable<
  Awaited<ReturnType<typeof archiveWarehouse>>
>;

export type ArchiveWarehouseMutationError =
  ErrorType<void | HTTPValidationError>;

/**
 * @summary Archive Warehouse
 */
export const useArchiveWarehouse = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof archiveWarehouse>>,
      TError,
      { warehouseId: number; shouldArchive: boolean },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof archiveWarehouse>>,
  TError,
  { warehouseId: number; shouldArchive: boolean },
  TContext
> => {
  const mutationOptions = getArchiveWarehouseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
